<div class="create-post-input bg-white d-flex" (click)="open()">
    <div class="profile-icon">
        <!-- <img src="https://ui-avatars.com/api/?background=random" alt="icon"> -->
        <ng-container *ngIf="profileUrl">
          <img src="{{profileUrl}}" alt="icon">
        </ng-container>
        <ng-container *ngIf="!profileUrl && customProfileName">
          <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">{{customProfileName}}</div>
          <!-- <img src="https://ui-avatars.com/api/?background=random" alt="icon"> -->
        </ng-container>
        <ng-container *ngIf="!profileUrl && !customProfileName">
          <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">G</div>
        </ng-container>
    </div>
    <div class="input-info">
        <div class="input-group flex-nowrap">
            <div class="input-group-prepend">
                <button class="btn btn-link" type="button" id="button-addon1">+ </button>
            </div>
            <input type="text" class="form-control" placeholder="Create a Post" aria-label="Example text with button addon" aria-describedby="button-addon1">
        </div>
        <!-- <ul class="list-inline mt-3 mb-0">
            <li class="list-inline-item">
                <a href="#"><img src="assets/images/attachment-icon.svg" alt="attachment" class="mr-2"> Attach Photo</a>
            </li>
            <li class="list-inline-item">
                <a href="#"><img src="assets/images/scan-doc-icon.svg" alt="attachment" class="mr-2"> Scan Document</a>
            </li>
        </ul> -->

        <!-- <div class="col-md-8">
          <ul class="list-inline  mb-0 d-flex align-items-center h-100">
              <li class="list-inline-item">
                  <input type="file" (change)="fileChangeEventUpload($event.target.files)" style="display:none;" #fileUpload>
                  <div class="text-dark" style="cursor: pointer;" (click)="fileUpload.click()">
                    <img src="assets/images/attachment-icon.svg" alt="attachment" class="mr-2">
                    Attach Photo
                  </div>
                  <div *ngIf="fileName" class="outer-file">
                    <div class="upload-file-name">{{fileName}}</div>
                   <div class="remove-icon"><i class="fa fa-remove" style="font-size:24px;color:red" (click)="removeFile()"></i></div>
                  </div>
                     <div *ngIf="showSupportText">
                                              <span class="text-warning">{{supportText}}</span>
                                            </div>
              </li>
              <li class="list-inline-item">
                  <a href="#" class="text-dark"><img src="assets/images/scan-doc-icon.svg" alt="attachment" class="mr-2"> Scan Document</a>
              </li>
          </ul>
      </div> -->
    </div>
</div>
